export const APPBAR_HEIGHT = 68.5;

/*
  The logo's drawn height, and deliberately not APPBAR_HEIGHT.

  It used to be the bar height exactly, so the mark ran from the very top edge to the very
  bottom one with no clear space at all. A wordmark touching both edges of its bar reads as
  oversized however big it actually is — the problem is the missing margin, not the pixels.
  At 40 it keeps ~14px of air above and below, which is the ratio the storefront header uses.
*/
export const APPBAR_LOGO_HEIGHT = 40;